
import React, {useEffect, useState} from 'react';
import Tabs from '@sabre/spark-react-core/tabs';
import Tab from '@sabre/spark-react-core/tab';

const TabsContainer = ({config}) => {
    const {
        tabActive = 0,
        tabOnClick = () => {},
        tabs = []
    } = config || {};

    const [tabDetails, setTabDetails] = useState(tabs);

    useEffect(() => {
        setTabDetails(tabs);
    }, [tabs]);

    return <Tabs
        className={`tabs-container${config.tabsContainerCss ? ` ${config.tabsContainerCss}` : ``}`}
        defaultTab={tabActive}
        onTabClick={tabOnClick}
    >
        {
            tabDetails.map((tabDetail, tabIndex) =>
                <Tab
                    key={`tab-${tabIndex}`}
                    title={tabDetail.tabTitle}>{tabDetail.tabContent}</Tab>)
        }
    </Tabs>
};

TabsContainer.propTypes = {

};

export default TabsContainer;
